// extracted by mini-css-extract-plugin
export var cSpinner = "Spinner-module--c-spinner--68561";
export var cSpinnerLarge = "Spinner-module--c-spinner--large--45049";
export var cSpinnerMedium = "Spinner-module--c-spinner--medium--ed5a8";
export var cSpinnerPrimary = "Spinner-module--c-spinner--primary--50f8a";
export var cSpinnerSmall = "Spinner-module--c-spinner--small--23a79";
export var cSpinnerXLarge = "Spinner-module--c-spinner--x-large--cb11a";
export var svgSpinnerInfiniteSpin = "Spinner-module--svg-spinner-infinite-spin--46989";